import { RoleUpdatePage } from '@/features/access/pages/role/RoleUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/access/role/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["auth_roles.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: RoleUpdatePage,
})
